module.exports = __webpack_public_path__ + "img/bq.63fa6eef.svg";